import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import LiveStreamCard from './components/LiveStreamCard';
import VideoModal from './components/VideoModal';
import { supabase } from '../../lib/supabase';

// Sample live streams for demonstration
const sampleLiveStreams = [
  {
    id: 1,
    church_name: 'Lagos Central SDA Church',
    state: 'Lagos',
    region: 'South West',
    conference: 'Lagos Mainland Conference',
    stream_title: 'Sabbath Worship Service',
    youtube_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    thumbnail_url: 'https://public.readdy.ai/ai/img_res/fc01260d67d5a6f27e389d9f6bc6d9ce.jpg',
    is_live: true,
    viewer_count: 1247,
    started_at: new Date().toISOString(),
    stream_type: 'Worship Service'
  },
  {
    id: 2,
    church_name: 'Abuja Garki SDA Church',
    state: 'FCT',
    region: 'North Central',
    conference: 'Abuja Conference',
    stream_title: 'Divine Service - Morning Worship',
    youtube_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    thumbnail_url: 'https://readdy.ai/api/search-image?query=elegant%20church%20sanctuary%20in%20Abuja%20with%20worshippers%20in%20formal%20attire%20contemporary%20architecture%20with%20glass%20windows%20natural%20lighting%20streaming%20through%20modern%20worship%20space%20with%20choir%20and%20pulpit&width=800&height=600&seq=abuja-garki-live-002&orientation=landscape',
    is_live: true,
    viewer_count: 892,
    started_at: new Date().toISOString(),
    stream_type: 'Worship Service'
  },
  {
    id: 3,
    church_name: 'Port Harcourt Rumuola SDA Church',
    state: 'Rivers',
    region: 'South South',
    conference: 'Rivers East Conference',
    stream_title: 'Sabbath School & Worship',
    youtube_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    thumbnail_url: 'https://readdy.ai/api/search-image?query=vibrant%20church%20service%20in%20Port%20Harcourt%20with%20enthusiastic%20congregation%20praising%20with%20raised%20hands%20contemporary%20worship%20band%20on%20stage%20colorful%20lighting%20and%20energetic%20atmosphere%20tropical%20church%20interior&width=800&height=600&seq=portharcourt-rumuola-live-003&orientation=landscape',
    is_live: true,
    viewer_count: 654,
    started_at: new Date().toISOString(),
    stream_type: 'Worship Service'
  },
  {
    id: 4,
    church_name: 'Ibadan Bodija SDA Church',
    state: 'Oyo',
    region: 'South West',
    conference: 'Oyo Conference',
    stream_title: 'Midweek Bible Study',
    youtube_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    thumbnail_url: 'https://readdy.ai/api/search-image?query=intimate%20Bible%20study%20session%20in%20Nigerian%20church%20with%20small%20group%20seated%20in%20circle%20discussing%20scripture%20warm%20lighting%20cozy%20atmosphere%20traditional%20church%20interior%20with%20wooden%20pews%20and%20pulpit&width=800&height=600&seq=ibadan-bodija-live-004&orientation=landscape',
    is_live: true,
    viewer_count: 328,
    started_at: new Date().toISOString(),
    stream_type: 'Bible Study'
  },
  {
    id: 5,
    church_name: 'Enugu Independence Layout SDA Church',
    state: 'Enugu',
    region: 'South East',
    conference: 'Enugu Conference',
    stream_title: 'Youth Ministry Live',
    youtube_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    thumbnail_url: 'https://readdy.ai/api/search-image?query=energetic%20youth%20church%20service%20in%20Enugu%20with%20young%20people%20worshipping%20contemporary%20praise%20and%20worship%20band%20modern%20stage%20setup%20with%20LED%20screens%20vibrant%20colorful%20lighting%20dynamic%20atmosphere&width=800&height=600&seq=enugu-independence-live-005&orientation=landscape',
    is_live: true,
    viewer_count: 512,
    started_at: new Date().toISOString(),
    stream_type: 'Youth Ministry'
  },
  {
    id: 6,
    church_name: 'Jos Central SDA Church',
    state: 'Plateau',
    region: 'North Central',
    conference: 'Plateau Conference',
    stream_title: 'Prayer Meeting',
    youtube_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    thumbnail_url: 'https://readdy.ai/api/search-image?query=peaceful%20prayer%20meeting%20in%20Jos%20church%20with%20congregation%20kneeling%20in%20prayer%20soft%20ambient%20lighting%20serene%20atmosphere%20traditional%20church%20sanctuary%20with%20altar%20and%20cross%20simple%20elegant%20interior&width=800&height=600&seq=jos-central-live-006&orientation=landscape',
    is_live: true,
    viewer_count: 245,
    started_at: new Date().toISOString(),
    stream_type: 'Prayer Meeting'
  },
  {
    id: 7,
    church_name: 'Victoria Island SDA Church',
    state: 'Lagos',
    region: 'South West',
    conference: 'Lagos Atlantic Conference',
    stream_title: 'Sunday Evening Service',
    youtube_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    thumbnail_url: 'https://readdy.ai/api/search-image?query=upscale%20modern%20church%20service%20on%20Victoria%20Island%20Lagos%20with%20well-dressed%20congregation%20contemporary%20architecture%20glass%20facade%20elegant%20interior%20design%20professional%20lighting%20and%20sound%20setup%20luxury%20worship%20space&width=800&height=600&seq=victoria-island-live-007&orientation=landscape',
    is_live: true,
    viewer_count: 1089,
    started_at: new Date().toISOString(),
    stream_type: 'Worship Service'
  },
  {
    id: 8,
    church_name: 'Kaduna Central SDA Church',
    state: 'Kaduna',
    region: 'North West',
    conference: 'North-West Nigeria Conference',
    stream_title: 'Sabbath Afternoon Program',
    youtube_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    thumbnail_url: 'https://readdy.ai/api/search-image?query=afternoon%20church%20program%20in%20Kaduna%20with%20congregation%20engaged%20in%20discussion%20panel%20speakers%20on%20stage%20educational%20setting%20within%20church%20sanctuary%20natural%20daylight%20through%20windows%20community%20gathering%20atmosphere&width=800&height=600&seq=kaduna-central-live-008&orientation=landscape',
    is_live: true,
    viewer_count: 423,
    started_at: new Date().toISOString(),
    stream_type: 'Special Event'
  },
  {
    id: 9,
    church_name: 'Calabar SDA Church',
    state: 'Cross River',
    region: 'South South',
    conference: 'Cross River Conference',
    stream_title: 'Evangelistic Campaign',
    youtube_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    thumbnail_url: 'https://readdy.ai/api/search-image?query=outdoor%20evangelistic%20crusade%20in%20Calabar%20with%20large%20tent%20filled%20with%20people%20preacher%20on%20elevated%20platform%20tropical%20evening%20setting%20coastal%20atmosphere%20enthusiastic%20crowd%20listening%20to%20gospel%20message&width=800&height=600&seq=calabar-live-009&orientation=landscape',
    is_live: true,
    viewer_count: 756,
    started_at: new Date().toISOString(),
    stream_type: 'Special Event'
  }
];

export default function Live() {
  const [liveStreams, setLiveStreams] = useState<any[]>(sampleLiveStreams);
  const [filteredStreams, setFilteredStreams] = useState<any[]>(sampleLiveStreams);
  const [loading, setLoading] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState<any>(null);
  const [selectedFilter, setSelectedFilter] = useState('All');

  useEffect(() => {
    fetchLiveStreams();
  }, []);

  const fetchLiveStreams = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('live_streams')
        .select('*')
        .eq('is_live', true)
        .order('started_at', { ascending: false });

      if (error) {
        console.warn('Using sample data:', error.message);
        setLiveStreams(sampleLiveStreams);
        setFilteredStreams(sampleLiveStreams);
      } else if (data && data.length > 0) {
        setLiveStreams(data);
        setFilteredStreams(data);
      } else {
        // Use sample data if no live streams in database
        setLiveStreams(sampleLiveStreams);
        setFilteredStreams(sampleLiveStreams);
      }
    } catch (err: any) {
      console.warn('Using sample data:', err.message);
      setLiveStreams(sampleLiveStreams);
      setFilteredStreams(sampleLiveStreams);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedFilter === 'All') {
      setFilteredStreams(liveStreams);
    } else {
      setFilteredStreams(liveStreams.filter(stream => stream.stream_type === selectedFilter));
    }
  }, [selectedFilter, liveStreams]);

  const streamTypes = ['All', 'Worship Service', 'Bible Study', 'Prayer Meeting', 'Youth Ministry', 'Special Event'];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 text-white">
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
          <div className="text-center">
            <div className="inline-flex items-center space-x-2 bg-emerald-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6 animate-pulse">
              <span className="w-3 h-3 bg-emerald-400 rounded-full"></span>
              <span className="text-sm font-bold text-white whitespace-nowrap">LIVE NOW</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: 'Noto Sans, system-ui, sans-serif' }}>
              Live Church Services
            </h1>
            <p className="text-lg sm:text-xl text-white/95 max-w-3xl mx-auto mb-8">
              Join worship services streaming live from SDA churches across Nigeria
            </p>

            {/* Stream Type Filters */}
            <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3">
              {streamTypes.map((type) => (
                <button
                  key={type}
                  onClick={() => setSelectedFilter(type)}
                  className={`px-4 sm:px-6 py-2 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
                    selectedFilter === type
                      ? 'bg-emerald-600 text-white shadow-lg'
                      : 'bg-white/10 text-white hover:bg-white/20 backdrop-blur-sm'
                  }`}
                >
                  {type}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Live Streams Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Loading State */}
        {loading && (
          <div className="text-center py-16">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-emerald-600 mb-4"></div>
            <p className="text-gray-600">Loading live streams...</p>
          </div>
        )}

        {/* Live Streams Grid */}
        {!loading && filteredStreams.length > 0 && (
          <>
            <div className="mb-6 flex items-center justify-between">
              <p className="text-sm text-gray-600">
                <strong>{filteredStreams.length}</strong> {filteredStreams.length === 1 ? 'church' : 'churches'} streaming live
              </p>
              <button
                onClick={fetchLiveStreams}
                className="px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-refresh-line"></i>
                Refresh
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredStreams.map((stream) => (
                <LiveStreamCard
                  key={stream.id}
                  stream={stream}
                  onClick={() => setSelectedVideo(stream)}
                />
              ))}
            </div>
          </>
        )}

        {/* Empty State */}
        {!loading && filteredStreams.length === 0 && (
          <div className="text-center py-16 bg-white rounded-xl shadow-md">
            <i className="ri-live-line text-6xl text-gray-300 mb-4"></i>
            <h3 className="text-xl font-bold text-gray-900 mb-2">No live streams</h3>
            <p className="text-gray-600 mb-6">
              {selectedFilter === 'All' 
                ? 'No churches are currently streaming. Check back later!'
                : `No ${selectedFilter} streams are currently live.`}
            </p>
            {selectedFilter !== 'All' && (
              <button
                onClick={() => setSelectedFilter('All')}
                className="px-6 py-2 bg-emerald-600 text-white rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                View All Streams
              </button>
            )}
          </div>
        )}
      </div>

      {/* Video Modal */}
      {selectedVideo && (
        <VideoModal
          stream={selectedVideo}
          onClose={() => setSelectedVideo(null)}
        />
      )}

      <Footer />
    </div>
  );
}
